import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

    render() {
        const reportDetails = this.props.reportDetails;
        const data = this.props.searchData;
        const totalCals = this.props.totalCals;

        return (
            <div align='left'>
                <h3><center><u>Supplier Payment Audit Report</u></center></h3>
                <div >&nbsp;</div>
                <Box minWidth={1150}>
                    <TableContainer>
                        <Table aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>GRN Number</TableCell>
                                    <TableCell align='left' style={{ whiteSpace: "nowrap" }}>GRN Date</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Supplier Code</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Supplier Name</TableCell>
                                    <TableCell align="right"style={{ whiteSpace: "nowrap" }}>GRN Amount</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Payment screen</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Payment Approval status</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 1st Approver</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 1st Approval Date</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 2nd Approver</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 2nd Approval Date</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 1st Approver</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 1st Approval Date</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 2nd Approver</TableCell>
                                    <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 2nd Approval Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportDetails.map((row) => (
                                    <TableRow key={row.grnNumber}>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.grnNumber ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                            {row.goodsReceiveDate ? moment(new Date(row.goodsReceiveDate)).format('YYYY-MM-DD') : '-'}
                                        </TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.supplierCode ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.supplierName ?? '-'}</TableCell>
                                        <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                                            {row.amount !== undefined && row.amount !== null
                                                ? parseFloat(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                : '-'}
                                        </TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                            {(row.isReinitiate === true && row.isActive === true)
                                                ? "Payment Reinitiate Screen"
                                                : "GRN Summary Approval Screen"}
                                        </TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                            {row.approvalStatus == 1 ? "New"
                                                : row.approvalStatus == 2 ? "FDC First Approved"
                                                    : row.approvalStatus == 3 ? "FDC Second Approved"
                                                        : row.approvalStatus == 4 ? "Finance First Approved"
                                                            : row.approvalStatus == 5 ? "Finance Second Approved"
                                                                : row.approvalStatus == 6 ? "FDC First Rejected"
                                                                    : row.approvalStatus == 7 ? "FDC Second Rejected"
                                                                        : row.approvalStatus == 8 ? "Finance First Rejected"
                                                                            : row.approvalStatus == 9 ? "Finance Second Rejected"
                                                                                : "Active"}
                                        </TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcFirst ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcUserTime ? moment(row.fdcUserTime).format('YYYY-MM-DD HH:mm') : '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcSec ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcApproverUserTime ? moment(row.fdcApproverUserTime).format('YYYY-MM-DD HH:mm') : '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeFirst ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeApprover1UserTime ? moment(row.financeApprover1UserTime).format('YYYY-MM-DD HH:mm') : '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeSec ?? '-'}</TableCell>
                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeApprover2UserTime ? moment(row.financeApprover2UserTime).format('YYYY-MM-DD HH:mm') : '-'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableRow>
                                <TableCell align="left"><b>Total</b></TableCell>
                                <TableCell colSpan={3} />
                                <TableCell align="right"><b>{parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                <TableCell colSpan={10} />
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}



